import React, { createContext, useContext } from 'react';
import { TNotification, useNotification } from '../hooks/use-notification.hook';
import { Notifications } from '../ui';

export type TNotificationContext = {
  notifications: TNotification[];
  addNotification: (notification: TNotification) => void;
  removeNotification: (id: number) => void;
};

export const NotificationContext = createContext<TNotificationContext | null>(
  null
);

export const NotificationContextProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const value = useNotification();

  return (
    <NotificationContext.Provider value={value}>
      <Notifications />
      {children}
    </NotificationContext.Provider>
  );
};

export const useNotificationContext = (): TNotificationContext => {
  const context = useContext(NotificationContext);

  if (!context) {
    throw new Error(
      'useNotificationContext must be used within a NotificationContextProvider'
    );
  }

  return context;
};
